/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrganizationType,
    OrganizationTypeFromJSON,
    OrganizationTypeFromJSONTyped,
    OrganizationTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationOnboarding
 */
export interface OrganizationOnboarding {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    organizationName?: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof OrganizationOnboarding
     */
    organizationType?: OrganizationType;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    organizationLocale?: string;
    /**
     * Google Place ID
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    firstWorkspaceLocation?: string;
    /**
     * Name of the first workspace, optional. If not set, this will be the street address from firstWorkspaceLocation
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    firstWorkspaceName?: string;
    /**
     * The unique identifier for the connection.
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    connectionId?: string;
    /**
     * The token for the email address of the owning user/first admin. For companies, the domain of the email address will also be associated with this organization and no other companies can use it.
     * @type {string}
     * @memberof OrganizationOnboarding
     */
    ownerEmailToken?: string;
}

export function OrganizationOnboardingFromJSON(json: any): OrganizationOnboarding {
    return OrganizationOnboardingFromJSONTyped(json, false);
}

export function OrganizationOnboardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOnboarding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
        'organizationType': !exists(json, 'organizationType') ? undefined : OrganizationTypeFromJSON(json['organizationType']),
        'organizationLocale': !exists(json, 'organizationLocale') ? undefined : json['organizationLocale'],
        'firstWorkspaceLocation': !exists(json, 'firstWorkspaceLocation') ? undefined : json['firstWorkspaceLocation'],
        'firstWorkspaceName': !exists(json, 'firstWorkspaceName') ? undefined : json['firstWorkspaceName'],
        'connectionId': !exists(json, 'connectionId') ? undefined : json['connectionId'],
        'ownerEmailToken': !exists(json, 'ownerEmailToken') ? undefined : json['ownerEmailToken'],
    };
}

export function OrganizationOnboardingToJSON(value?: OrganizationOnboarding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organizationName': value.organizationName,
        'organizationType': OrganizationTypeToJSON(value.organizationType),
        'organizationLocale': value.organizationLocale,
        'firstWorkspaceLocation': value.firstWorkspaceLocation,
        'firstWorkspaceName': value.firstWorkspaceName,
        'connectionId': value.connectionId,
        'ownerEmailToken': value.ownerEmailToken,
    };
}


